import { render, staticRenderFns } from "./TempRoutePage.vue?vue&type=template&id=bbc4e33a"
import script from "./TempRoutePage.vue?vue&type=script&lang=js"
export * from "./TempRoutePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports